export default {
  name: 'BuyFlow',
  computed: {},
  methods: {}
};
